"use client";

import clsx from "clsx";
import { useState } from "react";
import { ExpandDescriptionButton } from "./ExpandDescriptionButton";
import styles from "./description.module.css";

type Props = {
  text?: string;
};

// Maximum number of characters to display before truncating the description
const THRESHOLD = 200;

export const Description = ({ text }: Props) => {
  const hasMetThreshold = !!text ? text.length > THRESHOLD : false;

  const [isExpanded, setIsExpanded] = useState(hasMetThreshold);

  return (
    <div>
      <p
        className={clsx(
          styles.pdpDescription,
          isExpanded && styles["line-clamp"]
        )}
      >
        {text}
      </p>

      {hasMetThreshold && (
        <ExpandDescriptionButton
          toggleExpand={() => setIsExpanded(!isExpanded)}
          isExpanded={isExpanded}
        />
      )}
    </div>
  );
};
